import React from "react";
import { CalendarDays, ShieldCheck, Star, Store } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const testimonials = [
  { name: "Maya R." },
  { name: "James L." },
  { name: "Sofia K." },
];

const proofs = [
  Store,
  Star,
  ShieldCheck,
  CalendarDays,
];

export default function TrustSection() {
  const { t } = useLanguage();
  const copy = t("kylendar.trust");

  return (
    <section id="trust" className="home-wash relative border-y border-brand-100 bg-brand-surface/70 py-20 sm:py-24">
      <span className="home-orb right-10 top-16 h-52 w-52 bg-emerald-300/35" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
        <div className="home-section-mark mx-auto max-w-2xl text-center">
          <p className="home-eyebrow">{copy.eyebrow}</p>
          <h2 className="home-title mt-3">{copy.title}</h2>
        </div>

        <div className="mx-auto mt-12 grid max-w-5xl gap-4 md:grid-cols-3">
          {testimonials.map((item, index) => {
            const [quote, role] = copy.testimonials[index];
            return (
            <figure
              key={item.name}
              className="rounded-2xl border border-white/90 bg-gradient-to-br from-white to-brand-50/70 p-6 shadow-[0_18px_40px_-34px_rgba(15,23,42,.4)]"
            >
              <div className="flex gap-0.5 text-brand" aria-label={t("accessibility.rating")}>
                {[0, 1, 2, 3, 4].map((star) => (
                  <Star key={star} className="h-4 w-4 fill-current" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-4 text-sm leading-6 text-slate-600">“{quote}”</blockquote>
              <figcaption className="mt-5 border-t border-slate-100 pt-4">
                <p className="text-sm font-bold text-slate-950">{item.name}</p>
                <p className="text-xs text-slate-500">{role}</p>
              </figcaption>
            </figure>
            );
          })}
        </div>

        <div className="mx-auto mt-10 grid max-w-5xl gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {proofs.map((Icon, index) => {
            const [title, body] = copy.proofs[index];
            return (
            <div key={title} className="rounded-xl bg-white/70 px-4 py-4 text-center sm:text-left">
              <Icon className="mx-auto h-5 w-5 text-brand-700 sm:mx-0" aria-hidden="true" />
              <p className="mt-2 text-sm font-bold text-slate-900">{title}</p>
              <p className="mt-1 text-xs leading-5 text-slate-500">{body}</p>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
